import * as apiActions from "@configuratorware/configurator-frontendgui/App/Reducers/Actions";
import { dismissError } from "@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions";
import Api from "@configuratorware/configurator-frontendgui/Framework/Api";
import { get } from "lodash";
import { setLogOff } from "../Login/Actions";

export const actions = {
  ADD_TO_BASKET: "ADD_TO_BASKET",
  RECEIVE_BASKET: "RECEIVE_BASKET",
  SET_SELECTED_BASKET_ITEM: "SET_SELECTED_BASKET_ITEM",
  SET_SELECTED_ITEM_AMOUNT: "SET_SELECTED_ITEM_AMOUNT",
  CLEAR_BASKET: "CLEAR_BASKET",
  RECIEVE_MAIL: "RECIEVE_MAIL",
  CLEAR_BASKET_DATA: "CLEAR_BASKET_DATA",
  RECEIVE_ORDERS: "RECEIVE_ORDERS",
  SET_MAIL_ERROR: "SET_MAIL_ERROR",
  SET_CONFIGURATION_LOAD_FROM_LIST: "SET_CONFIGURATION_LOAD_FROM_LIST",
  SET_SHOW_SELECTOR: "SET_SHOW_SELECTOR"
};

export const fetchBasket = () => (dispatch, getState) => {
  const uuid = getState().basket.uuid;
  const isLoggedIn = getState().login.isLoggedIn;
  const selectedSkiSchool = getState().login.selectedSkiSchool;
  const token = getState().login.token;
  if(isLoggedIn && !token) {
    return;
  }
  token && Api.setTokenHeader(token);
  return dispatch(apiActions.fetchData(
    `basket${isLoggedIn && selectedSkiSchool ? "?school_id=" + selectedSkiSchool.id : uuid ? "?uuid=" + uuid : ""}`, 
    receiveBasket
  ));
}

export const clearBasket = () => ({
  type: actions.CLEAR_BASKET
})

export const clearBasketData = () => ({
  type: actions.CLEAR_BASKET_DATA
})

export const receieveMail = (data)  => (dispatch, getState) => {
  if(data.code === 401) {
    return dispatch(setLogOff())
  }
  dispatch(clearBasketData());
  dispatch({
    type: actions.RECIEVE_MAIL
  })
}
export const updateBasket = (item) => (dispatch, getState) => {
  const uuid = getState().basket.uuid;
  const isLoggedIn = getState().login.isLoggedIn;
  const selectedSkiSchool = getState().login.selectedSkiSchool;
  const token = getState().login.token;
  token && Api.setTokenHeader(token);
  return dispatch(apiActions.postData(
    `basket/update-amounts/item/${item.id}${isLoggedIn && selectedSkiSchool ? "?school_id=" + selectedSkiSchool.id : uuid ? "?uuid=" + uuid : ""}`,
    get(item, "configuration.customdata.selectedAmounts", {}),
    receiveBasket
  ));
}


export const updateBasketByConfigurationCode = (item) => (dispatch, getState) => {
  const uuid = getState().basket.uuid;
  const isLoggedIn = getState().login.isLoggedIn;
  const selectedSkiSchool = getState().login.selectedSkiSchool;
  return dispatch(apiActions.postData(
    `basket/update-amounts/${item.configuration.code}${isLoggedIn && selectedSkiSchool ? "?school_id=" + selectedSkiSchool.id : uuid ? "?uuid=" + uuid : ""}`,
    get(item, "configuration.customdata.selectedAmounts", {}),
    receiveBasket
  ));
}


export const receiveBasket = (data) => (dispatch, getState) => {
  if(data.code === 401) {
    return dispatch(setLogOff())
  }
  return dispatch({
    type: actions.RECEIVE_BASKET,
    data,
  })
};

export const receiveOrders = (data) => (dispatch, getState) => {
  if(data.code === 401) {
    return dispatch(setLogOff())
  }
  return dispatch({
    type: actions.RECEIVE_ORDERS,
    data,
  })
};

export const setSelectedBasketItem = (item) => ({
  type: actions.SET_SELECTED_BASKET_ITEM,
  item,
});

export const setSelectedAmount = (amount, identifier) => ({
  type: actions.SET_SELECTED_ITEM_AMOUNT,
  identifier,
  amount
});

export const setShowSelector = (flag) => ({
  type: actions.SET_SHOW_SELECTOR,
  flag,
});

export const addToBasket = (code, options = {showSelector: false}) => (dispatch, getState) => {
  const uuid = getState().basket.uuid;
  const isLoggedIn = getState().login.isLoggedIn;
  const selectedSkiSchool = getState().login.selectedSkiSchool;
  dispatch(apiActions.postData(
    `basket${isLoggedIn && selectedSkiSchool ? "?school_id=" + selectedSkiSchool.id : uuid ? "?uuid=" + uuid : ""}`,
    {code: code},
    receiveBasket
  ));
  options.showSelector && dispatch(setShowSelector(options.showSelector));
};

export const deleteBasketItem = (id) => async (dispatch, getState) => {
  const uuid = getState().basket.uuid;
  const isLoggedIn = getState().login.isLoggedIn;
  const selectedSkiSchool = getState().login.selectedSkiSchool;
  const token = getState().login.token;
  token && Api.setTokenHeader(token);
  await (Api.request({ 
    url: `basket/item/${id}${isLoggedIn && selectedSkiSchool ? "?school_id=" + selectedSkiSchool.id : uuid ? "?uuid=" + uuid : ""}`, 
    method: 'delete',
    data: null
  }))
  return dispatch(fetchBasket());
};

export const deleteBasketItemByConfigurationCode = (code) => async (dispatch, getState) => {
  const uuid = getState().basket.uuid;
  const isLoggedIn = getState().login.isLoggedIn;
  const selectedSkiSchool = getState().login.selectedSkiSchool;
  await (Api.request({ 
    url: `basket/configuration/${code}${isLoggedIn && selectedSkiSchool ? "?school_id=" + selectedSkiSchool.id : uuid ? "?uuid=" + uuid : ""}`, 
    method: 'delete',
    data: null
  }))
  return dispatch(fetchBasket());
};

export const fetchOrders = () => (dispatch, getState) => {
  const selectedSkiSchool = getState().login.selectedSkiSchool;
  const uuid = getState().basket.uuid;
  const token = getState().login.token;
  const isLoggedIn = getState().login.isLoggedIn;
  if(isLoggedIn && !token) {
    return;
  }
  token && Api.setTokenHeader(token);
  return dispatch(apiActions.fetchData(
    `order-history${isLoggedIn && selectedSkiSchool ? "?school_id=" + selectedSkiSchool.id : uuid ? "?uuid=" + uuid : ""}`, 
    receiveOrders
  ));
}

export const sendMail = (data) => async (dispatch, getState) => {
  const uuid = getState().basket.uuid;
  const isLoggedIn = getState().login.isLoggedIn;
  const selectedSkiSchool = getState().login.selectedSkiSchool;
  const token = getState().login.token;
  token && Api.setTokenHeader(token);
  return dispatch(apiActions.postData(
    `basket/send-mail${isLoggedIn && selectedSkiSchool ? "?school_id=" + selectedSkiSchool.id : uuid ? "?uuid=" + uuid : ""}`,
    {
      ...data
    },
    receieveMail,
  )).then((response) => {
    if(get(response, 'error', false)) {
      dispatch({
        type: actions.SET_MAIL_ERROR
      })
      return dispatch(dismissError())
    }
  })
}

export const setConfigurationFromList = (data) => ({
  type: actions.SET_CONFIGURATION_LOAD_FROM_LIST,
  data
})